import { useProjektRechte } from "../../contexts/ProjektRechteContext";
import { PageType } from "../../types";
import { bereichZurSeite } from "../../utils/zugriff";

/**
 * Berechtigungen für eine Projektseite.
 *
 * Löst die Seite auf ihren Bereich auf und fragt die effektiven Rechte des Projekts ab.
 * Anders als `usePagePermissions` (Auth0-Token, außerhalb eines Projekts) berücksichtigt
 * dieser Hook auch projektbezogene Freigaben an externe Personen.
 */
export const useSeitenRechte = (seite: PageType) => {
  const { darfSehen, darfBearbeiten, geladen } = useProjektRechte();
  const bereich = bereichZurSeite(seite);

  return {
    /** Solange die Rechte laden, wird nichts gesperrt – sonst blitzt die Sperrseite auf. */
    canView: !geladen || darfSehen(bereich),
    canEdit: geladen && darfBearbeiten(bereich),
    geladen,
    bereich,
  };
};
